import { Component, Input, type OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { BdcSendLicenseInfoPayloadData, BdcVariantWithValues } from '@tokeet-frontend/channel-content'
import { BdcLicenseRequirementsWithValues } from '@tokeet-frontend/channel-content'
import { SaveForm } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'

@Component({
  selector: 'app-bdc-licenses-form',
  templateUrl: './bdc-licenses-form.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class BdcLicensesFormComponent implements OnInit {
  _licenses: BdcLicenseRequirementsWithValues

  @Input() set licenses(data: BdcLicenseRequirementsWithValues) {
    this._licenses = data
    this.refreshLicenseForm(data?.submittedVariantId)
  }
  get licenses() {
    return this._licenses
  }

  form = this.fb.group({
    submittedVariantId: [undefined, [Validators.required]],
  })

  selectedVariant: BdcVariantWithValues

  samples: Record<string, string> = {}

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {}

  refreshLicenseForm(submittedVariantId: number) {
    const ctrlNames = Object.keys(this.form.controls).filter((n) => n !== 'submittedVariantId')
    ctrlNames.forEach((c) => this.form.removeControl(c))

    this.selectedVariant = this.licenses?.variants?.find((t) => t.id === submittedVariantId)
    this.selectedVariant?.content?.forEach((item) => {
      const ctrl = this.fb.control(item.value || '', item.required ? [Validators.required] : [])
      if (item.format) {
        ctrl.addValidators([Validators.pattern(item.format)])
      }

      this.form.addControl(item.name, ctrl)
    })

    this.form.patchValue(
      {
        submittedVariantId,
        ...this.selectedVariant?.content?.reduce((acc, item) => {
          acc[item.name] = item.value
          return acc
        }, {} as any),
      },
      { emitEvent: false }
    )
  }

  @SaveForm()
  private _getFormData(form: FormGroup) {
    const { submittedVariantId, ...variantData } = this.form.getRawValue()
    const contentData = lodash.toPairs(variantData).map(([name, value]) => ({ name, value: (value as any) || '' }))
    const payload: BdcSendLicenseInfoPayloadData = {
      contentData,
      variantId: submittedVariantId,
    }

    return payload
  }

  getFormData() {
    return this._getFormData(this.form)
  }
}
